import React, { useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useHistory } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';
import { loggerSipEnableSystem, loggerSipDownloadSystem, accessLocalStorage } from '../../services';

import '../../libs/bulma.min.css';

const ipGetRequest = window.location.href;
const myIP = ipGetRequest.split('/')[2].includes(':') ? ipGetRequest.split('/')[2].split(':')[0] : ipGetRequest.split('/')[2];

const socket = io(`http://${myIP}`, { 
  path: "/io/",
  withCredentials: true
});
socket.on('connection-vigoscloud', (evt) => evt)

function LogsVigoscloud() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden } = getItensStateGlobal;

  const history = useHistory();

  let url = window.location.href;
  url = url.split('/')[2];

  const [ logs, setlogs ] = useState([]);
  const [ pause, setPause ] = useState(true);
  const [ enableSipButton, setEnableSipButton ] = useState(true);
  const [ enableDownloadBotton, setEnableDownloadBotton ] = useState(true);
  const [ pid, setPid ] = useState(null);

  if (pause) socket.disconnect();
  if (!pause) socket.connect();

  // const handleDownloadLog = async () => {
  //   const response = await loggerSipDownloadSystem();
  //   if (response.status !== 200) {
  //     setMessage(response.data?.message || "Erro ao fazer download.");
  //     return;
  //   }
  //   const blob = new Blob([response.data]);
  //   const link = document.createElement('a');
  //   link.href = window.URL.createObjectURL(blob);
  //   link.download = 'logs-sip-vigoscloud.pcap';
  //   link.click();
  //   window.URL.revokeObjectURL(link);
  //   setTimeout(() => window.location.reload(), 5000);
  // };
  const handleDownloadLog = async () => {
    try {
      const response = await loggerSipDownloadSystem();
      
      if (response.status !== 200) {
        setMessage(response.data?.message || "Erro ao fazer download.");
        return;
      }
      
      // Cria o blob e o URL a partir do blob
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      
      // Cria um link e dispara o download
      const link = document.createElement('a');
      link.href = url;
      link.download = 'logs-sip-vigoscloud.pcap';
      
      // (Opcional) Insere o link no DOM para melhor compatibilidade
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Revoga o objeto URL após o uso
      window.URL.revokeObjectURL(url);
      
      // Se necessário, recarrega a página após 5 segundos
      setTimeout(() => window.location.reload(), 5000);
      
    } catch (error) {
      setMessage("Erro ao fazer download.");
      console.error("Erro no download do log:", error);
    }
  };

  const enableMonitorLogs = (value) => {
    setPause(value);
    setEnableSipButton(value)
    toggleIsHidden('#enable-logs');
    toggleIsHidden('#disable-logs');
  };

  const handleChangeLogsSip = async (state) => {
    const sendCommand = await loggerSipEnableSystem({ statusSip: state });
    // if (sendCommand.status === 200) setPid();
    if (state === 'off') setEnableDownloadBotton(false);
    toggleIsHidden('#enable-sip-logs');
    toggleIsHidden('#disable-sip-logs');
  };

  const verifyIsUserTec = () => {
    const user = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = user;
    if (role !== 'root') return history.push('/home');
  };

  useEffect(() => {
    socket.on('log', (data) => {
      setlogs((prevState) => {
        if (prevState.length < 12) {
          return [...prevState, data]
        } else {
          prevState.shift();
          return [...prevState, data]
        }
      });
    });
  }, [socket, pause]);

  useEffect(() => {
    verifyIsUserTec();
  }, []);

  return (
    <div>
      <div className="columns mt-3">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">VIGOSCLOUD LOGS</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article className="column message is-10 is-offset-1">
        <div className="message-header has-text-centered">
          <button className="button is-success is-1 is-active is-small" id="enable-logs" type="submit" onClick={ () => enableMonitorLogs(false) }>
            <span>
              Logs ON 
            </span>
          </button>
          <button className="button is-danger is-1 is-hidden is-small px-4" id="disable-logs" type="submit" onClick={ () => enableMonitorLogs(true) }>
            <span>
              Logs OFF
            </span>
          </button>
          <p className="has-text-centered">LOGS</p>
          <button className="button is-info is-1 is-small" id="download-sip-logs" type="submit" onClick={ () => handleDownloadLog()} disabled={ enableDownloadBotton }>
            <span>
              Download
            </span>
          </button>
          <button className="button is-success is-1 is-active is-small" id="enable-sip-logs" type="submit" onClick={ () => handleChangeLogsSip('on') } disabled={ enableSipButton }>
            <span>
              SIP ON 
            </span>
          </button>
          <button className="button is-danger is-1 is-hidden is-small" id="disable-sip-logs" type="submit" onClick={ () => handleChangeLogsSip('off') }>
            <span>
              SIP OFF
            </span>
          </button>
        </div>
        <div className="message-body">
          <pre className="is-family-code has-text-weight-light has-background-light">
            { logs.map((item, index) => <p className="is-family-code" key={index}>{ item }</p>) }
          </pre>
        </div>
      </article>
    </div>
  );
}

export default LogsVigoscloud;
